import { normalizeAppLocale, type AppLocale } from '~/utils/appLocale'

function cookieOptions() {
  const secure = import.meta.client
    ? window.location.protocol === 'https:'
    : useRequestURL().protocol === 'https:'

  return {
    sameSite: 'lax' as const,
    secure,
    path: '/',
  }
}

export function persistAppLocale(code: unknown): AppLocale | null {
  const normalized = normalizeAppLocale(code)
  if (!normalized || !process.client) return normalized

  const languageCookie = useCookie<string | null>('language', cookieOptions())
  languageCookie.value = normalized
  useSetSafeStorage('currentLanguage', normalized)
  useSetSafeStorage('i18n_redirected', normalized)
  return normalized
}

export function readExplicitAppLocale(): AppLocale | null {
  if (!process.client) return null

  const languageCookie = useCookie<string | null>('language', cookieOptions())
  return (
    normalizeAppLocale(languageCookie.value) ||
    normalizeAppLocale(localStorage.getItem('currentLanguage')) ||
    normalizeAppLocale(localStorage.getItem('i18n_redirected'))
  )
}
